import useSession from '@/hooks/useSession';
import { AuthoritiesType } from '@/types/Authority';

export function hasPermissions(authorities: AuthoritiesType[], some = false) {
  function useHasPermission() {
    const accessToken = useSession();

    if (some) {
      return authorities.some((permission) =>
        accessToken?.authorities?.includes(permission),
      );
    }

    return authorities.every((permission) =>
      accessToken?.authorities?.includes(permission),
    );
  }

  return useHasPermission();
}
